// extracted by mini-css-extract-plugin
export default {"primary":"styles_primary__jsW+A","secondary":"styles_secondary__7EPht","danger":"styles_danger__mjaNG","action":"styles_action__AaME7"};